import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getLoginCompanyEmployeeSuccess} from "../store/selectors/companyEmployee.selector";
import { Route } from "@angular/router";
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private store: Store, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.pipe(
      select(getLoginCompanyEmployeeSuccess),
      take(1),
      map((user) => {
        console.log('------------user-', user)
        // Check if user is logged in
        if (user) {
          // If the user is logged in, allow navigation
          return true;
        } else {
          sessionStorage.clear()
          // If not logged in, redirect to login page or other page
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
}
